<template>
  <button
    class="t-ButtonIcon"
    type="button"
    :disabled="disabled"
    @click="handleClick"
  >
    <span class="t-ButtonIcon-Content">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  name: 'ButtonIcon',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.t-ButtonIcon {
  background: transparent;
  border: none;
  color: var(--organization-secondary-color);
  cursor: pointer;
  font-size: var(--track-font-size-xxs);
  outline: none;
}

.t-ButtonIcon-Content {
  i {
    color: var(--track-color-bluegray-80);
    font-size: 19px;
  }

  :not(i) {
    text-decoration: underline;
  }
}
</style>
